import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  sendOTP,
  onlyVerifyOTP,
  registerUser,
} from "../../../../redux/zservices/BasicAPIFunctions"; 
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch } from "react-redux";
import { getProfile } from "../../../../redux/profile/action";
import { disabledStyle } from "../../../Common/ClickDisable";
import mobileotpImg from '../../../../../src/assests/imgs/mobile-otp.svg';
import mailotpImg from '../../../../../src/assests/imgs/email-otp.svg';

const VerifyEmailMobile = ({ valuess, setNextpage }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lan, setLan] = useState(localStorage.getItem("laung") ?? "en");
  
  const values = valuess;
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  console.log(values,"akdvljndslkvn");

  // Determine if it's a social login (has token and is not empty)
  const isSocialLogin = values?.social_token && values.social_token.trim() !== "";

  // Step Control: 1 for Mobile, 2 for Email
  const [currentStep, setCurrentStep] = useState(1);

  // OTP States for 6 boxes
  const [mobileOtp, setMobileOtp] = useState(new Array(6).fill(""));
  const [emailOtp, setEmailOtp] = useState(new Array(6).fill(""));

  const [emailVerified, setEmailVerified] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);

  const [timeLeft, setTimeLeft] = useState(60); // For Email
  const [canResend, setCanResend] = useState(false);
  const [timeLeft1, setTimeLeft1] = useState(60); // For Mobile
  const [canResend1, setCanResend1] = useState(false);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, []);

  // Timer for Email Resend
  useEffect(() => {
    if (!timeLeft) {
      setCanResend(true);
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  // Timer for Mobile Resend
  useEffect(() => {
    if (!timeLeft1) {
      setCanResend1(true);
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft1(timeLeft1 - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft1]);

  // Auto Submit when conditions are met
  useEffect(() => {
    if (isSocialLogin) {
      if (mobileVerified) {
        handleSubmit();
      }
    } else {
      if (mobileVerified && emailVerified) {
        handleSubmit();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileVerified, emailVerified, isSocialLogin]);

  // Handle individual OTP input changes
  const handleOtpChange = (element, index, type) => {
    const value = element.value;
    if (isNaN(value)) return; // Only allow numbers

    if (type === "mobile") {
      const newOtp = [...mobileOtp];
      newOtp[index] = value.substring(value.length - 1); // Take last digit if multiple typed
      setMobileOtp(newOtp);
      
      // Move to next input
      if (value && element.nextSibling) {
        element.nextSibling.focus();
      }

      // Auto-submit if all 6 digits are entered
      if (newOtp.every((char) => char !== "")) {
        verifyMobileOTP(newOtp.join(""));
      }

    } else {
      const newOtp = [...emailOtp];
      newOtp[index] = value.substring(value.length - 1);
      setEmailOtp(newOtp);
      
      // Move to next input
      if (value && element.nextSibling) {
        element.nextSibling.focus();
      }

      // Auto-submit if all 6 digits are entered
      if (newOtp.every((char) => char !== "")) {
        verifyEmailOTP(newOtp.join(""));
      }
    }
  };

  // Handle backspace to move focus to previous input
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

  const sendEmailOTP = () => {
    setLoading(true);
    setTimeLeft(60);
    setCanResend(false);
    const data = { email_id: values?.email_id };
    if (values?.is_whatsapp === 1) data.is_whatsapp = 1;

    sendOTP(data)
      .then((res) => {
        if (res.data.status) urtoast(res.data.response?.message, 1);
        else urtoast(res.data.response?.message, 2);
      })
      .catch((e) => urtoast(e?.message, 2))
      .finally(() => setTimeout(() => setLoading(false), 2000));
  };

  const sendMobileOTP = () => {
    setLoading(true);
    setTimeLeft1(60);
    setCanResend1(false);
    const data = {
      mobile_number: values?.mobile_number,
      country_code: values?.country_code,
    };
    if (values?.is_whatsapp === 1) data.is_whatsapp = 1;

    sendOTP(data)
      .then((res) => {
        if (res.data.status) urtoast(res.data.response?.message, 1);
        else urtoast(res.data.response?.message, 2);
      })
      .catch((e) => urtoast(e?.message, 2))
      .finally(() => setTimeout(() => setLoading(false), 2000));
  };

  // Accepts an optional parameter to prevent state staleness during auto-submit
  const verifyMobileOTP = (autoSubmitString) => {
    const otpString = typeof autoSubmitString === "string" ? autoSubmitString : mobileOtp.join("");
    if (otpString.length < 6) return; // Prevent verifying incomplete OTP

    setLoading(true);
    const data = {
      mobile_number: values?.mobile_number,
      country_code: values?.country_code,
      otp: otpString,
    };
    
    onlyVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
          setMobileVerified(true);
          
          // Only proceed to step 2 if NOT a social login
          if (!isSocialLogin) {
            setCurrentStep(2); 
          }
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => urtoast(e?.message, 2))
      .finally(() => setTimeout(() => setLoading(false), 2000));
  };

  // Accepts an optional parameter to prevent state staleness during auto-submit
  const verifyEmailOTP = (autoSubmitString) => {
    const otpString = typeof autoSubmitString === "string" ? autoSubmitString : emailOtp.join("");
    if (otpString.length < 6) return;

    setLoading(true);
    const data = {
      email_id: values?.email_id,
      otp: otpString,
    };
    if (values?.is_whatsapp === 1) data.is_whatsapp = 1;

    onlyVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
          setEmailVerified(true); // Triggers handleSubmit via useEffect
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => urtoast(e?.message, 2))
      .finally(() => setTimeout(() => setLoading(false), 2000));
  };

  const handleSubmit = () => {
    setLoading(true);
    registerUser(values)
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem("urexperttoken", res.data.response.token);
          localStorage.setItem("role_type", res.data.response.role_type);
          dispatch(getProfile());
          navigate(`/${lan}/registrationsuccessful`);
          urtoast(res.data.response?.message, 1);
          window.location.reload();
        } else {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => urtoast(e?.message, 2))
      .finally(() => setTimeout(() => setLoading(false), 2000));
  };

  return (
    <>
      {/* ---------- STEP 1: MOBILE OTP ---------- */}
      {currentStep === 1 && (
        <div className="mx-auto register email">
          <img className="mail-img" src={mobileotpImg} alt="Mobile OTP" />
          <h1>Verify mobile no.</h1>
          <p>
            OTP has been sent to the mobile number{" "}
            <strong>
              {values?.country_code} {values?.mobile_number}{" "}
            </strong>
            <span>Please check your device shortly</span>
          </p>
          <a
            style={{ cursor: "pointer", ...(loading ? disabledStyle : {}) }}
            onClick={() => setNextpage(true)}
          >
            Use different number
          </a>

          <div className="form-sec col-lg-12 col-md-7 mx-auto mt-4">
            <div className="form-group">
              <label>Enter Mobile OTP</label>
              <div className="otp-secs d-flex justify-content-between mb-3">
                {mobileOtp.map((data, index) => (
                  <input
                    className="form-control text-center mx-1"
                    type="text"
                    name="mobileOtp"
                    maxLength="1"
                    key={index}
                    value={data}
                    onChange={(e) => handleOtpChange(e.target, index, "mobile")}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))}
              </div>
              <button
                className="w-100 otp-verify background-button"
                type="button"
                onClick={() => verifyMobileOTP()}
                disabled={loading || mobileOtp.join("").length < 6}
              >
                Verify Mobile
              </button>
            </div>

            <div className="col-lg-12 col-md-7 mx-auto last-form text-center mt-3">
              <p className="d-flex justify-content-center re-a">
               <span>Didn’t receive OTP?{" "}</span>
                <a
                  type="button"
                  style={{ cursor: "pointer", ...(loading || mobileVerified ? disabledStyle : {}) }}
                  className={`login-password mx-0 ${mobileVerified ? "disabled-link" : ""}`}
                  onClick={sendMobileOTP}
                >
                  {canResend1 ? "Resend" : `Resend in: ${timeLeft1}s`}
                </a>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ---------- STEP 2: EMAIL OTP ---------- */}
      {currentStep === 2 && !isSocialLogin && (
        <div className="mx-auto register email">
          <img className="mail-img" src={mailotpImg} alt="Email OTP" />
          <h1>Verify email</h1>
          <p>
            We’ve sent a 6 digit verification code to your email{" "}
            <strong>{values?.email_id}</strong>
          </p>
          <div className="d-flex justify-content-between w-100 px-3">
            <a
              style={{ cursor: "pointer", ...(loading ? disabledStyle : {}) }}
              onClick={() => setNextpage(true)}
            >
              Use different email
            </a>
          </div>

          <div className="form-sec col-lg-12 col-md-7 mx-auto mt-4">
            <div className="form-group">
              <label>Enter Email OTP</label>
              <div className="otp-secs d-flex justify-content-between mb-3">
                {emailOtp.map((data, index) => (
                  <input
                    className="form-control text-center mx-1"
                    type="text"
                    name="emailOtp"
                    maxLength="1"
                    key={index}
                    value={data}
                    onChange={(e) => handleOtpChange(e.target, index, "email")}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))}
              </div>
              <button
                className="w-100 otp-verify background-button"
                type="button"
                onClick={() => verifyEmailOTP()}
                disabled={loading || emailOtp.join("").length < 6}
              >
                Verify & Submit
              </button>
            </div>

            <div className="col-lg-12 col-md-7 mx-auto last-form text-center mt-3">
              <p className="d-flex justify-content-center re-a">
                <span>Didn’t receive OTP?{" "}</span>
                <a
                  type="button"
                  style={{ cursor: "pointer", ...(loading || emailVerified ? disabledStyle : {}) }}
                  className={`login-password m-0 ${emailVerified ? "disabled-link" : ""}`}
                  onClick={sendEmailOTP} 
                >
                  {canResend ? "Resend" : `Resend in: ${timeLeft}s`}
                </a>
              </p>
              {emailVerified && <p className="text-success mt-2">Loading...</p>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VerifyEmailMobile;